import { FiX } from 'react-icons/fi';

import { CircularProgress, IconButton } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TOASTER_TYPE, ToastMessage } from '../../../../../components';
import { images } from '../../../../../constant';
import { usePayLinkUser } from '../../../context/PaylinkUserContext';
import { removePayLinkCardToken } from '../../../services/api';

export const SelectedPaymentMethod = () => {
  const { cardToken, setCardToken } = usePayLinkUser();
  const queryClient = useQueryClient();

  const removeCardTokenMutation = useMutation({
    mutationFn: removePayLinkCardToken,
    onSuccess: () => {
      setCardToken(null);
      queryClient.invalidateQueries({ queryKey: ["PayLinkCardTokens"] });
      ToastMessage(TOASTER_TYPE.SUCCESS, "Card removed successfully");
    },
    onError: () => {
      ToastMessage(TOASTER_TYPE.ERROR, "Unable to remove card. Please try again.");
    },
  });

  const handleRemoveCard = () => {
    if (!cardToken || removeCardTokenMutation.isLoading) return;

    removeCardTokenMutation.mutate({
      uniqueReferenceNumber: cardToken.uniqueReferenceNumber,
      customerUniqueReferenceNumber: cardToken.customerUniqueReferenceNumber,
      walletUniqueReferenceNumber: cardToken.walletUniqueReferenceNumber,
      gatewayCustomerId: cardToken.gatewayCustomerId,
      emailAddress: cardToken.emailAddress,
      paymentMethodUniqueReferenceNumber:
        cardToken.paymentMethodUniqueReferenceNumber,
    });
  };

  return (
    <section className="rounded-2xl bg-[#F5F5F6] p-4">
      <div className="flex items-center justify-between gap-3">
        <h3 className="text-base text-py_black-950 font-medium tracking-[-0.02em] leading-[140%]">
          Payment method
        </h3>
        {cardToken && (
          <IconButton
            size="small"
            aria-label="Remove card"
            disabled={removeCardTokenMutation.isLoading}
            onClick={handleRemoveCard}
            className="!p-1 !text-py_black-500 hover:!text-red-600">
            {removeCardTokenMutation.isLoading ? (
              <CircularProgress size={14} />
            ) : (
              <FiX size={16} />
            )}
          </IconButton>
        )}
      </div>

      {cardToken ? (
        <div className="mt-3 inline-flex !gap-4 items-center justify-between text-sm w-full">
          <h4 className="text-py_black-500 font-medium leading-[140%]">
            Debit/ Credit Card
          </h4>

          <div className="inline-flex items-center !gap-1 !ml-auto">
            {cardToken.cardType?.toLowerCase().includes("visa") && (
              <img
                src={images.VisaLogo}
                alt="visa logo"
                className="w-[26px] h-[16px] object-cover"
              />
            )}
            {cardToken.cardType?.toLowerCase().includes("verve") && (
              <img
                src={images.VerveLogo}
                alt="verve logo"
                className="w-[46px] h-[16px] object-cover"
              />
            )}
            {cardToken.cardType?.toLowerCase().includes("mastercard") && (
              <img
                src={images.MasterCardLogo}
                alt="mastercard logo"
                className="w-[26px] h-[16px] object-cover"
              />
            )}
            <span className="text-py_black-950 font-normal leading-[120%]">
              ***{cardToken.lastFourDigit}
            </span>
          </div>
        </div>
      ) : (
        <p className="mt-3 text-sm text-py_black-500">-</p>
      )}
    </section>
  );
};
